import React, { useState }  from 'react';
import { useGetAllDisputesQuery, DisputeModel } from '../../../../../../../../redux/services/MerchantApi';
import styles from '../content.module.css';
import { statusesTranslate } from '../../statuses';
const DisputesBlocks: React.FC = () => {
  const { data = [], isLoading, error } = useGetAllDisputesQuery(undefined, { pollingInterval: 10000 });
  const [filter, setFilter] = useState('');

  if (isLoading) return <div>Загрузка споров...</div>;
  if (error) return <div>Ошибка загрузки споров</div>;

  // Открытые диспуты
  let open = data.filter(d => d.status === 'in_dispute');

  // Применяем фильтр по order или withdrawId
  if (filter.trim()) {
    const f = filter.trim().toLowerCase();
    open = open.filter(d =>
      String(d.order).toLowerCase().includes(f) ||
      String(d.withdrawal ?? '').toLowerCase().includes(f)
    );
  }

  return (
    <div>
      <input
        className={styles.filterInput}
        type="text"
        placeholder="Введите order или withdrawal ID"
        value={filter}
        onChange={e => setFilter(e.target.value)}
      />

      <div className={styles.blocksContainer}>
        {open.length ? (
          open.map(d => (
            <div key={d.id} className={styles.disputeCard}>
              <div className={styles.cardHeader}>
                Диспут по {d.withdrawal ? 'выводу' : 'заявке'}: {d.withdrawal ?? d.order}
              </div>
              <div className={styles.cardBody}>
                <div>Сумма: {d.summa}</div>
                <div>Order: {d.order}</div>
                {d.withdrawal && <div>Withdraw ID: {d.withdrawal}</div>}
                <div>Статус:{statusesTranslate[d.status] ?? d.status}</div>
              </div>
              <div className={styles.cardFooter}>
                {new Date(d.create_dt).toLocaleString()}
              </div>
            </div>
          ))
        ) : (
          <div>Нет диспутов по заданному фильтру</div>
        )}
      </div>
    </div>
  );
};

export default DisputesBlocks;
